import { maxDelay } from "../../constants";
export function getRenewInterval(expirationTime) {
    let expirationTimeInMiliseconds = expirationTime * 1000;
    // The five seconds are based on the BE code in method: GetExpiration
    // new DateTime(1970, 1, 1, 0, 0, 0, DateTimeKind.Utc).AddSeconds(seconds - 5).Subtract(DateTime.UtcNow);
    let result = Math.abs((expirationTimeInMiliseconds - 5000) - Date.now());
    return (result <= maxDelay) ? result : maxDelay;
}
//# sourceMappingURL=renewInterval.js.map